import { collection, getFirestore, query, getDocs, where, limit, startAfter, orderBy, getCountFromServer } from "firebase/firestore";
import abrechnungConverter from "../Abrechnung/abrechnungConverter";

export default class AbrechnungenLoader {

    sorts = [
        { id: 1, name: 'versionId', direction: 'desc' },
        { id: 2, name: 'versionId', direction: 'asc' },
        { id: 3, name: 'abrechnender.nachname', direction: 'asc' },
        { id: 4, name: 'abrechnender.nachname', direction: 'desc' },
        { id: 5, name: 'empfaenger.name', direction: 'asc' },
        { id: 6, name: 'empfaenger.name', direction: 'desc' },
        { id: 7, name: 'empfaenger.ausschuss.name', direction: 'asc' },
        { id: 8, name: 'empfaenger.ausschuss.name', direction: 'desc' }
    ]

    constructor(...args) {
        this.abrechnungenRef = collection(getFirestore(), "Abrechnungen");
        this.startAt = 1;
        this.limit = 50;
        this.currentLimit = 50;
        this.lastAfter = null;
        this.args = args;
        this.last_query_args = [];
    }

    set_args(...args){
        this.args = args;
    }

    async get_count(...args){
        const all_args = this.args.concat(args);
        let q = query(this.abrechnungenRef, ...all_args);
        const querySnapshot = await getCountFromServer(q);
        return querySnapshot?.data()?.count || 0;
    }

    async get(id) {
        const docRef = doc(this.abrechnungenRef, id).withConverter(abrechnungConverter);
        const docSnap = await getDocs(docRef);
        if (docSnap.exists()) {
            return docSnap.data();
        } else {
            console.error("No such document!");
        }
    }

    async load(sort, filter, ...args) {
        const sortParam = this.sorts.find(item => item.id == sort) ?? this.sorts[0];
        const all_args = this.args.concat(args);
        this.last_query_args = all_args;
        const q = query(this.abrechnungenRef, ...all_args, orderBy(sortParam.name, sortParam.direction), limit(this.limit)).withConverter(abrechnungConverter);
        const querySnapshot = await getDocs(q);
        const abrechnungen = []
        querySnapshot.forEach((doc) => {
            abrechnungen.push(doc.data());
        });

        this.lastAfter = querySnapshot.docs[querySnapshot.docs.length - 1];

        return abrechnungen.filter(item => {
            if (filter) {
                return Object.keys(filter).every(key => {
                    if (key === 'empfaenger') {
                        return filter[key].includes(item.empfaenger.refId);
                    }
                    return true;
                });
            }
            return true;
        });
    }

    async loadMore(sort, filter) {
        if(!this.lastAfter){
            return []
        }
        const sortParam = this.sorts.find(item => item.id == sort) ?? this.sorts[0];
        const q = query(this.abrechnungenRef, ...this.last_query_args, orderBy(sortParam.name, sortParam.direction), startAfter(this.lastAfter), limit(this.limit)).withConverter(abrechnungConverter);
        const querySnapshot = await getDocs(q);
        const abrechnungen = []
        querySnapshot.forEach((doc) => {
            abrechnungen.push(doc.data());
        });
        this.lastAfter = querySnapshot.docs[querySnapshot.docs.length - 1];
        this.currentLimit += this.limit;
        return abrechnungen.filter(item => {
            if (filter) {
                return Object.keys(filter).every(key => {
                    if (key === 'empfaenger') {
                        return filter[key].includes(item.empfaenger.refId);
                    }
                    return true;
                });
            }
            return true;
        });
    }
}